var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivitiesWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1922_4403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1156 10.995H22C21.8392 9.3769 21.2865 7.86936 20.4523 6.57288C18.7136 7.40705 17.4473 9.03519 17.1156 10.995Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88442 10.995C6.55276 9.03519 5.28643 7.40705 3.54774 6.57288C2.71357 7.86936 2.1608 9.3769 2 10.995H6.88442Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0854 10.995C15.407 8.39196 16.9749 6.1809 19.1658 4.96482C17.5578 3.32663 15.407 2.24121 13.005 2V10.995H15.0854Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91463 10.995H10.995V2C8.59302 2.24121 6.43222 3.32663 4.83423 4.96482C7.02518 6.1809 8.59302 8.39196 8.91463 10.995Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0854 13.0049H13.005V21.9999C15.407 21.7587 17.5678 20.6732 19.1658 19.035C16.9749 17.819 15.407 15.6079 15.0854 13.0049Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54774 17.427C5.27638 16.5928 6.55276 14.9546 6.88442 13.0049H2C2.1608 14.623 2.71357 16.1305 3.54774 17.427Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1156 13.0049C17.4473 14.9647 18.7136 16.5928 20.4523 17.427C21.2865 16.1305 21.8392 14.623 22 13.0049H17.1156Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91463 13.0049C8.59302 15.6079 7.02518 17.819 4.83423 19.035C6.44227 20.6732 8.59302 21.7587 10.995 21.9999V13.0049H8.91463Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1922_4403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesWhite);
export default __webpack_public_path__ + "static/media/activities-white.f7ebe6d17d2515e2b785cecd0a944c87.svg";
export { ForwardRef as ReactComponent };